import { createContext } from 'react';

type LanguageOption = {
    label: string;
    value: string;
    code: string;
};

export type LanguageContextData = {
    currentLanguageId: string;
    setCurrentLanguageId: (languageId: string) => void;
    languageOptions: LanguageOption[];
};

export const LanguageContext = createContext<LanguageContextData | null>(null);
